import React, { useState, useEffect } from 'react';
import { Tabs, AutoComplete, Card, Table, Button, Modal, Form, Input, Select, Tag, Space, message, Tooltip, Popconfirm, Row, Col, Upload, Progress, Badge, Divider, Checkbox, Radio } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, UserSwitchOutlined, SearchOutlined, WhatsAppOutlined, UploadOutlined, EyeOutlined, DownloadOutlined } from '@ant-design/icons';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;
const { TextArea } = Input;

const STATUS_CORES = { novo: 'blue', contatado: 'orange', interessado: 'green', proposta_enviada: 'purple', sem_interesse: 'red', convertido: 'success' };
const STATUS_LABELS = { novo: 'Novo', contatado: 'Contatado', interessado: 'Interessado', proposta_enviada: 'Proposta Enviada', sem_interesse: 'Sem Interesse', convertido: 'Convertido' };
const ORIGENS = ['manual', 'linkedin', 'site', 'indicacao', 'google', 'instagram', 'telefone', 'outro'];

export default function Leads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [importando, setImportando] = useState(false);
  const [progressoImport, setProgressoImport] = useState(0);
  const [resultadoImport, setResultadoImport] = useState(null);
  const [enriquecendo, setEnriquecendo] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [modalDetalhe, setModalDetalhe] = useState(false);
  const [leadDetalhe, setLeadDetalhe] = useState(null);
  const [emailsLead, setEmailsLead] = useState([]);
  const [telefonesLead, setTelefonesLead] = useState([]);
  const [enriquecimentoLead, setEnriquecimentoLead] = useState(null);
  const [historicoLead, setHistoricoLead] = useState([]);
  const [lembretesLead, setLembretesLead] = useState([]);
  const [novoContato, setNovoContato] = useState({ tipo: 'ligacao', descricao: '', resultado: 'sem_resposta' });
  const [novoLembrete, setNovoLembrete] = useState({ descricao: '', data_lembrete: '' });
  const [filtroBairro, setFiltroBairro] = useState('');
  const [filtroCidade, setFiltroCidade] = useState('');
  const [filtroTipo, setFiltroTipo] = useState('');
  const [filtroCnae, setFiltroCnae] = useState('');
  const [editando, setEditando] = useState(null);
  const [busca, setBusca] = useState('');
  const [dominios, setDominios] = useState([]);
  const [dominioEscolhido, setDominioEscolhido] = useState('');
  const [buscandoEmails, setBuscandoEmails] = useState(false);
  const [bloqueados, setBloqueados] = useState([]);
  const [novoBloq, setNovoBloq] = useState({ termo: '', tipo: 'parcial', motivo: 'contabilidade' });
  const [padroesEmail, setPadroesEmail] = useState([]);
  const [novoPadrao, setNovoPadrao] = useState({ padrao: '', area: 'geral' });
  const carregarProspeccao = async () => {
    try {
      const [b, pe] = await Promise.all([
        api.get('/prospeccao/bloqueados'), api.get('/prospeccao/padroes')]);
      setBloqueados(b.data || []); setPadroesEmail(pe.data || []);
    } catch (e) {}
  };
  useEffect(() => { carregarProspeccao(); }, []);
  const [filtroStatus, setFiltroStatus] = useState('');
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filtroStatus) params.status = filtroStatus;
      if (busca) params.busca = busca;
      const r = await api.get('/leads', { params });
      setLeads(r.data);
    } catch { message.error('Erro ao carregar leads'); }
    finally { setLoading(false); }
  };

  useEffect(() => { carregar(); }, [filtroStatus, busca]);

  const abrirDetalhe = async (lead) => {
    setLeadDetalhe(lead);
    setModalDetalhe(true);
    try {
      const [emails, telefones, enrich, hist, lemb, doms] = await Promise.all([
        api.get(`/leads/${lead.id}/emails`),
        api.get(`/leads/${lead.id}/telefones`),
        api.get(`/leads/${lead.id}/enriquecimento`),
        api.get(`/leads/${lead.id}/historico`),
        api.get(`/leads/${lead.id}/lembretes`),
        api.get(`/prospeccao/lead/${lead.id}/dominios`),
      ]);
      setEmailsLead(emails.data || []);
      setTelefonesLead(telefones.data || []);
      setEnriquecimentoLead(enrich.data || null);
      setHistoricoLead(hist.data || []);
      setLembretesLead(lemb.data || []);
      setDominios(doms.data?.candidatos || []);
      setDominioEscolhido(doms.data?.escolhido || '');
    } catch(e) {}
  };

  const exportarLeads = async () => {
    try {
      const lista = leadsFiltrados.length > 0 ? leadsFiltrados : leads;
      const headers = ['Razão Social', 'Nome Fantasia', 'CNPJ', 'Bairro', 'Cidade', 'Estado', 'CNAE', 'Porte', 'Sócios', 'Abertura', 'E-mail', 'Telefone', 'Site', 'WhatsApp', 'Instagram'];
      const rows = lista.map(l => [
        l.razao_social || '', l.nome_fantasia || '', l.cnpj || '',
        l.bairro || '', l.cidade || '', l.estado || '',
        l.cnae_principal || '', l.porte || '', l.socios || '',
        l.data_abertura ? new Date(l.data_abertura).toLocaleDateString('pt-BR') : '',
        l.email || '', l.telefone || '',
        l.site || '', l.whatsapp_gemini || '', ''
      ]);
      const csv = [headers, ...rows].map(r => r.map(v => '"' + String(v).replace(/"/g, '""') + '"').join(';')).join('\n');
      const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'leads_' + new Date().toISOString().split('T')[0] + '.csv';
      a.click();
      message.success('Exportado com sucesso!');
    } catch(e) { message.error('Erro ao exportar'); }
  };

  const registrarContato = async () => {
    if (!novoContato.descricao) { message.warning('Descreva o contato'); return; }
    try {
      await api.post(`/leads/${leadDetalhe.id}/historico`, novoContato);
      message.success('Contato registrado!');
      const hist = await api.get(`/leads/${leadDetalhe.id}/historico`);
      setHistoricoLead(hist.data || []);
      setNovoContato({ tipo: 'ligacao', descricao: '', resultado: 'sem_resposta' });
      carregar();
    } catch(e) { message.error('Erro ao registrar'); }
  };

  const salvarLembrete = async () => {
    if (!novoLembrete.descricao || !novoLembrete.data_lembrete) { message.warning('Preencha o lembrete'); return; }
    try {
      await api.post(`/leads/${leadDetalhe.id}/lembretes`, novoLembrete);
      message.success('Lembrete salvo!');
      const lemb = await api.get(`/leads/${leadDetalhe.id}/lembretes`);
      setLembretesLead(lemb.data || []);
      setNovoLembrete({ descricao: '', data_lembrete: '' });
    } catch(e) { message.error('Erro ao salvar lembrete'); }
  };

  const concluirLembrete = async (id) => {
    try {
      await api.put(`/leads/lembretes/${id}/concluir`);
      const lemb = await api.get(`/leads/${leadDetalhe.id}/lembretes`);
      setLembretesLead(lemb.data || []);
    } catch(e) {}
  };

  const excluirSelecionados = async () => {
    if (!selectedRows.length) return;
    try {
      await Promise.all(selectedRows.map(id => api.delete('/leads/' + id)));
      message.success(`${selectedRows.length} leads excluídos!`);
      setSelectedRows([]);
      carregar();
    } catch(e) { message.error('Erro ao excluir'); }
  };

  const [mtModal, setMtModal] = useState(false);
  const [mtSegmentos, setMtSegmentos] = useState([]);
  const [mtSegmento, setMtSegmento] = useState(null);
  const [mtModo, setMtModo] = useState('principal');
  const [mtEmails, setMtEmails] = useState([]);
  const [mtEmailsSel, setMtEmailsSel] = useState([]);
  const [mtEnviando, setMtEnviando] = useState(false);

  const sincronizarMauticSelecionados = async () => {
    if (!selectedRows.length) return;
    setMtSegmento(null); setMtEmails([]); setMtEmailsSel([]); setMtModo('principal');
    setMtModal(true);
    try {
      const r = await api.get('/leads/mautic/segmentos');
      setMtSegmentos(r.data || []);
    } catch { message.error('Erro ao buscar segmentos do Mautic'); }
    if (selectedRows.length === 1) {
      try {
        const r = await api.get('/leads/' + selectedRows[0] + '/emails');
        setMtEmails(r.data || []);
        setMtEmailsSel((r.data || []).filter(e => e.valido !== false).map(e => e.email));
      } catch { message.error('Erro ao buscar e-mails do lead'); }
    }
  };

  const confirmarMautic = async () => {
    if (!mtSegmento) { message.warning('Escolha o segmento'); return; }
    if (selectedRows.length === 1 && !mtEmailsSel.length) { message.warning('Marque pelo menos um e-mail'); return; }
    setMtEnviando(true);
    let ok = 0, falha = 0;
    for (const id of selectedRows) {
      try {
        const body = selectedRows.length === 1 ? { segmento_id: mtSegmento, emails: mtEmailsSel } : { segmento_id: mtSegmento, modo: mtModo };
        const r = await api.post('/leads/' + id + '/mautic', body);
        ok += (r.data?.resultados || []).filter(x => x.mautic_id).length;
      } catch { falha++; }
    }
    setMtEnviando(false);
    message.success(ok + ' contato(s) enviado(s) ao Mautic' + (falha ? ', ' + falha + ' lead(s) com erro' : ''));
    setMtModal(false); setSelectedRows([]); carregar();
  };

  const importarCSV = async (file) => {
    setImportando(true);
    setProgressoImport(10);
    try {
      const fd = new FormData();
      fd.append('arquivo', file);
      setProgressoImport(30);
      const r = await api.post('/leads/importar-csv', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setProgressoImport(100);
      setResultadoImport(r.data);
      message.success(`Importados: ${r.data.importados} | Duplicados: ${r.data.duplicados} | Erros: ${r.data.erros}`);
      carregar();
    } catch(e) { message.error('Erro ao importar: ' + (e.response?.data?.erro || e.message)); }
    finally { setImportando(false); setProgressoImport(0); }
    return false;
  };

  const enriquecerLead = async (id) => {
    setEnriquecendo(prev => ({ ...prev, [id]: true }));
    try {
      const r = await api.post(`/leads/${id}/enriquecer`);
      message.success('Lead enriquecido com sucesso!');
      carregar();
    } catch(e) { message.error('Erro ao enriquecer: ' + (e.response?.data?.erro || e.message)); }
    finally { setEnriquecendo(prev => ({ ...prev, [id]: false })); }
  };

  const enriquecerSelecionados = async () => {
    if (!selectedRows.length) { message.warning('Selecione pelo menos um lead'); return; }
    message.loading({ content: `Enriquecendo ${selectedRows.length} leads...`, key: 'enrich' });
    for (const id of selectedRows) {
      await enriquecerLead(id);
      await new Promise(r => setTimeout(r, 2000)); // Aguardar 2s entre cada
    }
    message.success({ content: 'Enriquecimento concluído!', key: 'enrich' });
    setSelectedRows([]);
  };

  const abrirModal = (lead = null) => {
    setEditando(lead);
    form.resetFields();
    if (lead) form.setFieldsValue(lead);
    setModal(true);
  };

  const salvar = async (values) => {
    try {
      if (editando) await api.put('/leads/' + editando.id, values);
      else await api.post('/leads', values);
      message.success(editando ? 'Lead atualizado!' : 'Lead criado!');
      setModal(false);
      carregar();
    } catch { message.error('Erro ao salvar lead'); }
  };

  const excluir = async (id) => {
    try {
      await api.delete('/leads/' + id);
      message.success('Lead removido!');
      carregar();
    } catch { message.error('Erro ao excluir'); }
  };

  const converter = async (lead) => {
    try {
      const r = await api.post('/leads/' + lead.id + '/converter');
      message.success('Lead convertido em cliente!');
      navigate('/clientes/' + r.data.cliente_id);
    } catch { message.error('Erro ao converter lead'); }
  };

  const buscarCNPJ = async (cnpj) => {
    const c = cnpj.replace(/\D/g, '');
    if (c.length !== 14) return;
    try {
      const r = await api.get('/cnpj/' + c);
      form.setFieldsValue({
        empresa: r.data.razao_social,
        cidade: r.data.municipio,
        estado: r.data.uf,
      });
      message.success('Dados preenchidos!');
    } catch { message.warning('CNPJ não encontrado'); }
  };

  // Filtrar leads
  // Ordenar por data de abertura (mais nova primeiro)
  const leadsOrdenados = [...leads].sort((a, b) => {
    if (!a.data_abertura) return 1;
    if (!b.data_abertura) return -1;
    return new Date(b.data_abertura) - new Date(a.data_abertura);
  });

  const leadsFiltrados = leadsOrdenados.filter(l => {
    if (filtroBairro && !(l.bairro || '').toLowerCase().includes(filtroBairro.toLowerCase())) return false;
    if (filtroCidade && !(l.cidade || '').toLowerCase().includes(filtroCidade.toLowerCase())) return false;
    if (filtroTipo && !(l.cnae_principal || '').toLowerCase().includes(filtroTipo.toLowerCase())) return false;
    if (filtroCnae && (l.cnae_principal || '').trim() !== filtroCnae) return false;
    return true;
  });

  // Bairros únicos para autocomplete
  const bairrosUnicos = [...new Set(leads.map(l => l.bairro).filter(Boolean))].sort();
  const cidadesUnicas = [...new Set(leads.map(l => l.cidade).filter(Boolean))].sort();

  const colunas = [
    { title: 'Nome', dataIndex: 'nome', key: 'nome', render: (v, r) => <><div><strong>{v}</strong></div><div style={{ fontSize: 12, color: '#888' }}>{r.empresa}</div></> },
    { title: 'Contato', key: 'contato', render: (_, r) => <><div>{r.email}</div><div>{r.telefone}</div></> },
    { title: 'Funil', key: 'funil', dataIndex: 'funil', width: 100, render: v => {
      const cores = { novo: 'default', contatado: 'blue', interessado: 'gold', proposta: 'purple', convertido: 'green', perdido: 'red' };
      const labels = { novo: '🆕 Novo', contatado: '📞 Contatado', interessado: '⭐ Interessado', proposta: '📄 Proposta', convertido: '✅ Convertido', perdido: '❌ Perdido' };
      return <Tag color={cores[v] || 'default'}>{labels[v] || v || 'Novo'}</Tag>;
    }},
    { title: 'Abertura', key: 'data_abertura', dataIndex: 'data_abertura',
      sorter: (a,b) => new Date(b.data_abertura) - new Date(a.data_abertura),
      render: v => {
        if (!v) return '-';
        const dias = Math.floor((new Date() - new Date(v)) / 86400000);
        const cor = dias <= 90 ? '#52c41a' : dias <= 365 ? '#fa8c16' : '#8c8c8c';
        const label = dias <= 90 ? '🟢' : dias <= 365 ? '🟡' : '⚪';
        return <span style={{color:cor, fontWeight: dias<=365?'bold':'normal'}} title={new Date(v).toLocaleDateString('pt-BR')}>{label} {dias}d</span>;
      }
    },
    { title: 'Bairro', key: 'bairro', dataIndex: 'bairro', render: v => v || '-' },
    { title: 'Cidade', key: 'cidade', render: (_, r) => r.cidade ? r.cidade + '/' + r.estado : '-' },
    { title: 'Origem', dataIndex: 'origem', key: 'origem', render: v => <Tag>{v}</Tag> },
    { title: 'Status', dataIndex: 'status', key: 'status', render: v => <Tag color={STATUS_CORES[v]}>{STATUS_LABELS[v]}</Tag> },
    { title: 'Mautic', dataIndex: 'mautic_id', key: 'mautic_id', render: v => v ? <Tag color="green">✓ {v}</Tag> : <Tag color="red">Não sincronizado</Tag> },
    { title: 'Ações', key: 'acoes', render: (_, r) => (
      <Space>
        <Tooltip title="Ver detalhes"><Button size="small" icon={<EyeOutlined />} onClick={() => abrirDetalhe(r)} /></Tooltip>
        <Tooltip title="Editar"><Button size="small" icon={<EditOutlined />} onClick={() => abrirModal(r)} /></Tooltip>
        <Tooltip title={r.enriquecido_em ? 'Enriquecido em ' + new Date(r.enriquecido_em).toLocaleDateString('pt-BR') + ' — clique para atualizar' : 'Enriquecer com IA (Gemini)'}>
          <Button size="small" loading={enriquecendo[r.id]} style={{ color: r.enriquecido_em ? '#52c41a' : '#4285f4', background: r.enriquecido_em ? '#f6ffed' : undefined }} onClick={() => enriquecerLead(r.id)}>{r.enriquecido_em ? '✅' : '🔍'}</Button>
        </Tooltip>
        {r.telefone && <Tooltip title="WhatsApp"><Button size="small" icon={<WhatsAppOutlined />} style={{ color: '#25d366' }} onClick={() => window.open('https://wa.me/55' + r.telefone.replace(/\D/g, ''))} /></Tooltip>}
        {!r.cliente_id && <Tooltip title="Converter em Cliente"><Button size="small" icon={<UserSwitchOutlined />} style={{ color: '#722ed1' }} onClick={() => converter(r)} /></Tooltip>}
        {r.cliente_id && <Tooltip title="Ver Cliente"><Button size="small" onClick={() => navigate('/clientes/' + r.cliente_id)}>Ver Cliente</Button></Tooltip>}
        <Popconfirm title="Excluir lead?" onConfirm={() => excluir(r.id)} okText="Sim" cancelText="Não">
          <Button size="small" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      </Space>
    )}
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <div><h2 style={{ margin: 0 }}>Leads</h2><p style={{ color: '#888', margin: 0 }}>Pré-contatos sincronizados com Mautic</p></div>
        <Space>
          <Upload beforeUpload={importarCSV} showUploadList={false} accept=".csv">
            <Button icon={<UploadOutlined />} loading={importando}>Importar CSV B2Leads</Button>
          </Upload>
          {selectedRows.length > 0 && (
            <Space>
              <span style={{ fontSize: 12, color: '#888' }}>{selectedRows.length} selecionados</span>
              <Button style={{ background: '#4285f4', color: '#fff' }} onClick={enriquecerSelecionados}>
                🔍 Enriquecer com IA
              </Button>
              <Button style={{ background: '#00b96b', color: '#fff' }} onClick={sincronizarMauticSelecionados}>
                📧 Sincronizar Mautic
              </Button>
              <Modal title="Enviar para o Mautic" open={mtModal} onCancel={() => setMtModal(false)} onOk={confirmarMautic} okText="Enviar" confirmLoading={mtEnviando}>
                <p style={{ marginBottom: 6 }}><strong>Segmento</strong></p>
                <Select style={{ width: '100%', marginBottom: 16 }} placeholder="Escolha o segmento" showSearch optionFilterProp="label" value={mtSegmento} onChange={setMtSegmento}
                  options={mtSegmentos.map(s => ({ value: s.id, label: s.nome + (s.publicado === false ? ' (despublicado)' : '') }))} />
                <p style={{ marginBottom: 6 }}><strong>E-mails</strong></p>
                {selectedRows.length === 1 ? (
                  mtEmails.length ? (
                    <Checkbox.Group value={mtEmailsSel} onChange={setMtEmailsSel} style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                      {mtEmails.map(e => <Checkbox key={e.email} value={e.email}>{e.email} {e.principal ? <Tag color="blue">principal</Tag> : null}{e.valido === false ? <Tag color="orange">genérico</Tag> : null}</Checkbox>)}
                    </Checkbox.Group>
                  ) : <p style={{ color: '#888' }}>Este lead não tem e-mail cadastrado.</p>
                ) : (
                  <Radio.Group value={mtModo} onChange={e => setMtModo(e.target.value)} style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <Radio value="principal">Só o e-mail principal de cada lead</Radio>
                    <Radio value="todos">Todos os e-mails válidos de cada lead (um contato por e-mail)</Radio>
                  </Radio.Group>
                )}
                <p style={{ color: '#888', fontSize: 12, marginTop: 12 }}>Cada e-mail vira um contato no Mautic (se já existir, só é atualizado e adicionado ao segmento).</p>
              </Modal>
              <Popconfirm title={`Excluir ${selectedRows.length} leads?`} onConfirm={excluirSelecionados}>
                <Button danger>🗑️ Excluir</Button>
              </Popconfirm>
            </Space>
          )}
          <Button icon={<DownloadOutlined />} onClick={exportarLeads}>Exportar CSV</Button>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => abrirModal()}>Novo Lead</Button>
        </Space>
      </div>
      <Tabs defaultActiveKey="lista">
        <Tabs.TabPane tab="Leads" key="lista">
      <Card size="small" style={{ marginBottom: 16 }}>
        <Row gutter={16}>
          <Col span={12}><Input placeholder="Buscar por nome, email ou empresa..." prefix={<SearchOutlined />} value={busca} onChange={e => setBusca(e.target.value)} /></Col>
          <Col span={6}><Select placeholder="Filtrar por status" style={{ width: '100%' }} allowClear value={filtroStatus || undefined} onChange={v => setFiltroStatus(v || '')}>
            {Object.entries(STATUS_LABELS).map(([k, v]) => <Option key={k} value={k}>{v}</Option>)}
          </Select></Col>
        </Row>
      </Card>
      <Card size="small">
        {/* Filtros */}
        <Row gutter={12} style={{ marginBottom: 12 }}>
          <Col span={5}>
            <Select showSearch allowClear placeholder="Filtrar por bairro" style={{ width: '100%' }}
              onChange={v => setFiltroBairro(v || '')} filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
              {bairrosUnicos.map(b => <Select.Option key={b} value={b}>{b}</Select.Option>)}
            </Select>
          </Col>
          <Col span={5}>
            <Select showSearch allowClear placeholder="Filtrar por cidade" style={{ width: '100%' }}
              onChange={v => setFiltroCidade(v || '')}>
              {cidadesUnicas.map(ci => <Select.Option key={ci} value={ci}>{ci}</Select.Option>)}
            </Select>
          </Col>
          <Col span={4}>
            <Select allowClear placeholder="Tipo de negócio" style={{ width: '100%' }}
              onChange={v => setFiltroTipo(v || '')}>
              <Select.Option value="odontol">Odontológica</Select.Option>
              <Select.Option value="médica ambulatorial">Médica</Select.Option>
              <Select.Option value="hospitalar">Hospitalar</Select.Option>
              <Select.Option value="veterinária">Veterinária</Select.Option>
              <Select.Option value="estética">Estética</Select.Option>
            </Select>
          </Col>
          <Col span={6}>
            <Select showSearch allowClear placeholder="Filtrar por CNAE" style={{ width: '100%' }} value={filtroCnae || undefined}
              onChange={v => setFiltroCnae(v || '')} optionFilterProp="label"
              options={(() => { const m = {}; leads.forEach(l => { const c = (l.cnae_principal || '').trim(); if (c) m[c] = (m[c] || 0) + 1; }); return Object.keys(m).sort((a, b) => m[b] - m[a] || a.localeCompare(b)).map(c => ({ value: c, label: c + ' (' + m[c] + ')' })); })()} />
          </Col>
          <Col span={4}>
            <Button onClick={() => { setFiltroBairro(''); setFiltroCidade(''); setFiltroTipo(''); setFiltroCnae(''); }}>Limpar filtros</Button>
            <span style={{ marginLeft: 8, color: '#888', fontSize: 12 }}>{leadsFiltrados.length} de {leads.length}</span>
          </Col>
        </Row>

        {importando && <Progress percent={progressoImport} style={{ marginBottom: 16 }} />}
        {resultadoImport && (
          <div style={{ marginBottom: 16, padding: 12, background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 6 }}>
            ✅ Importação concluída: <strong>{resultadoImport.importados}</strong> importados, <strong>{resultadoImport.duplicados}</strong> duplicados, <strong>{resultadoImport.erros}</strong> erros de <strong>{resultadoImport.total}</strong> registros
          </div>
        )}
        <Table 
          columns={colunas} 
          dataSource={leadsFiltrados} 
          rowKey="id" 
          loading={loading} 
          size="small" 
          locale={{ emptyText: 'Nenhum lead cadastrado.' }}
          rowSelection={{
            selectedRowKeys: selectedRows,
            onChange: (keys) => setSelectedRows(keys)
          }}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ['10', '25', '50', '100', '200', '500'],
            defaultPageSize: 25,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} leads`
          }}
        />
      </Card>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Prospecção" key="prospeccao">
          <Card size="small" title="Domínios bloqueados (contabilidade, jurídico, terceiros)"
            extra={<span style={{fontSize:12,color:'#888'}}>{bloqueados.length} cadastrados</span>}
            style={{ marginBottom: 16 }}>
            <p style={{ color: '#666', fontSize: 13 }}>
              Domínios aqui nunca geram e-mails na prospecção. Use <strong>parcial</strong> para um
              pedaço do nome (ex.: contabil pega qualquer domínio que contenha isso) ou
              <strong> exato</strong> para um escritório específico.
            </p>
            <Space.Compact style={{ width: '100%', marginBottom: 12 }}>
              <Input style={{ width: '40%' }} placeholder="termo ou domínio"
                value={novoBloq.termo}
                onChange={e => setNovoBloq({ ...novoBloq, termo: e.target.value })} />
              <Select style={{ width: '20%' }} value={novoBloq.tipo}
                onChange={v => setNovoBloq({ ...novoBloq, tipo: v })}
                options={[{value:'parcial',label:'Parcial'},{value:'exato',label:'Domínio exato'}]} />
              <Select style={{ width: '20%' }} value={novoBloq.motivo}
                onChange={v => setNovoBloq({ ...novoBloq, motivo: v })}
                options={[{value:'contabilidade',label:'Contabilidade'},{value:'juridico',label:'Jurídico'},{value:'terceiro',label:'Outro terceiro'}]} />
              <Button type="primary" onClick={async () => {
                if (!novoBloq.termo.trim()) return message.warning('Informe o termo');
                try { await api.post('/prospeccao/bloqueados', novoBloq);
                  message.success('Bloqueio salvo'); setNovoBloq({ ...novoBloq, termo: '' });
                  carregarProspeccao();
                } catch (e) { message.error(e.response?.data?.erro || 'Erro'); }
              }}>Adicionar</Button>
            </Space.Compact>
            <Table size="small" rowKey="id" dataSource={bloqueados} pagination={{ pageSize: 10 }}
              columns={[
                { title: 'Termo', dataIndex: 'termo' },
                { title: 'Tipo', dataIndex: 'tipo', width: 120, render: v => <Tag color={v === 'exato' ? 'blue' : 'default'}>{v}</Tag> },
                { title: 'Motivo', dataIndex: 'motivo', width: 150 },
                { title: '', width: 80, render: (_, r) => (
                  <Popconfirm title="Remover?" onConfirm={async () => {
                    await api.delete('/prospeccao/bloqueados/' + r.id);
                    message.success('Removido'); carregarProspeccao();
                  }}><Button size="small" danger>Excluir</Button></Popconfirm>) }
              ]} />
          </Card>

          <Card size="small" title="Padrões de e-mail gerados na prospecção"
            extra={<span style={{fontSize:12,color:'#888'}}>{padroesEmail.length} cadastrados</span>}>
            <p style={{ color: '#666', fontSize: 13 }}>
              O sistema monta estes endereços com o domínio aprovado de cada lead
              (ex.: compras@empresa.com.br). A área define o segmento no Mautic.
            </p>
            <Space.Compact style={{ width: '100%', marginBottom: 12 }}>
              <Input style={{ width: '40%' }} placeholder="padrão, sem o @ (ex.: financeiro)"
                value={novoPadrao.padrao}
                onChange={e => setNovoPadrao({ ...novoPadrao, padrao: e.target.value })} />
              <Select style={{ width: '30%' }} value={novoPadrao.area}
                onChange={v => setNovoPadrao({ ...novoPadrao, area: v })}
                options={[{value:'geral',label:'Geral'},{value:'compras',label:'Compras'},{value:'sst',label:'Segurança do trabalho'},{value:'manutencao',label:'Manutenção / Engenharia'},{value:'qualidade',label:'Qualidade'},{value:'financeiro',label:'Financeiro'}]} />
              <Button type="primary" onClick={async () => {
                if (!novoPadrao.padrao.trim()) return message.warning('Informe o padrão');
                try { await api.post('/prospeccao/padroes', novoPadrao);
                  message.success('Padrão salvo'); setNovoPadrao({ ...novoPadrao, padrao: '' });
                  carregarProspeccao();
                } catch (e) { message.error(e.response?.data?.erro || 'Erro'); }
              }}>Adicionar</Button>
            </Space.Compact>
            <Table size="small" rowKey="id" dataSource={padroesEmail} pagination={false}
              columns={[
                { title: 'Padrão', render: (_, r) => <code>{r.padrao}@...</code> },
                { title: 'Área', dataIndex: 'area', width: 200, render: v => <Tag>{v}</Tag> },
                { title: '', width: 80, render: (_, r) => (
                  <Popconfirm title="Remover?" onConfirm={async () => {
                    await api.delete('/prospeccao/padroes/' + r.id);
                    message.success('Removido'); carregarProspeccao();
                  }}><Button size="small" danger>Excluir</Button></Popconfirm>) }
              ]} />
          </Card>
        </Tabs.TabPane>
      </Tabs>

      <Modal title={editando ? 'Editar Lead' : 'Novo Lead'} open={modal} onCancel={() => setModal(false)} footer={null} width={700}>
        <Form form={form} layout="vertical" onFinish={salvar}>
          <Row gutter={16}>
            <Col span={12}><Form.Item name="nome" label="Nome" rules={[{ required: true }]}><Input /></Form.Item></Col>
            <Col span={12}><Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}><Form.Item name="telefone" label="Telefone"><Input /></Form.Item></Col>
            <Col span={12}><Form.Item name="cargo" label="Cargo / Profissão"><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}><Form.Item name="cnpj" label="CNPJ (opcional)"><Input placeholder="00.000.000/0000-00" onBlur={e => buscarCNPJ(e.target.value)} /></Form.Item></Col>
            <Col span={12}><Form.Item name="empresa" label="Empresa"><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}><Form.Item name="cidade" label="Cidade"><Input /></Form.Item></Col>
            <Col span={4}><Form.Item name="estado" label="Estado"><Input maxLength={2} /></Form.Item></Col>
            <Col span={6}><Form.Item name="origem" label="Origem" initialValue="manual"><Select>{ORIGENS.map(o => <Option key={o} value={o}>{o}</Option>)}</Select></Form.Item></Col>
            <Col span={6}><Form.Item name="status" label="Status" initialValue="novo"><Select>{Object.entries(STATUS_LABELS).map(([k, v]) => <Option key={k} value={k}>{v}</Option>)}</Select></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={10}><Form.Item name="endereco" label="Endereço (rua, número, complemento)"><Input /></Form.Item></Col>
            <Col span={8}><Form.Item name="bairro" label="Bairro"><Input /></Form.Item></Col>
            <Col span={6}><Form.Item name="cep" label="CEP"><Input placeholder="00000-000" /></Form.Item></Col>
          </Row>
          <Form.Item name="observacoes" label="Observações"><TextArea rows={3} /></Form.Item>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button onClick={() => setModal(false)}>Cancelar</Button>
            <Button type="primary" htmlType="submit">Salvar e Sincronizar Mautic</Button>
          </div>
        </Form>
      </Modal>

      {/* Modal de detalhes do lead */}
      <Modal title={leadDetalhe ? (leadDetalhe.nome_fantasia || leadDetalhe.razao_social || leadDetalhe.empresa) : 'Detalhes'} 
        open={modalDetalhe} onCancel={() => setModalDetalhe(false)} footer={null} width={800}>
        {leadDetalhe && (
          <div>
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col span={12}><strong>Razão Social:</strong><br/>{leadDetalhe.razao_social || '-'}</Col>
              <Col span={12}><strong>Nome Fantasia:</strong><br/>{leadDetalhe.nome_fantasia || '-'}</Col>
              <Col span={12} style={{ marginTop: 8 }}><strong>CNPJ:</strong><br/>{leadDetalhe.cnpj || '-'}</Col>
              <Col span={12} style={{ marginTop: 8 }}><strong>Abertura:</strong><br/>{leadDetalhe.data_abertura ? new Date(leadDetalhe.data_abertura).toLocaleDateString('pt-BR') : '-'}</Col>
              <Col span={12} style={{ marginTop: 8 }}><strong>Endereço:</strong><br/>{leadDetalhe.endereco || '-'}</Col>
              <Col span={12} style={{ marginTop: 8 }}><strong>Bairro/Cidade:</strong><br/>{leadDetalhe.bairro} - {leadDetalhe.cidade}/{leadDetalhe.estado}</Col>
              <Col span={24} style={{ marginTop: 8 }}><strong>CNAE:</strong><br/><span style={{fontSize:12}}>{leadDetalhe.cnae_principal || '-'}</span></Col>
              <Col span={12} style={{ marginTop: 8 }}><strong>Porte:</strong><br/>{leadDetalhe.porte || '-'}</Col>
              <Col span={12} style={{ marginTop: 8 }}><strong>Funcionários:</strong><br/>{leadDetalhe.quantidade_funcionarios || '-'}</Col>
              <Col span={12} style={{ marginTop: 8 }}><strong>Cargo / Profissão:</strong> {leadDetalhe.cargo || '-'}</Col>
              <Col span={24} style={{ marginTop: 8 }}><strong>Sócios:</strong><br/><span style={{fontSize:12}}>{leadDetalhe.socios || '-'}</span></Col>
            </Row>
            <Divider>🌐 Domínio para prospecção</Divider>
            <Space.Compact style={{ width: '100%', marginBottom: 8 }}>
              <AutoComplete style={{ width: '60%' }}
                placeholder="Cole ou digite o domínio (ex.: empresa.com.br)"
                value={dominioEscolhido}
                onChange={v => setDominioEscolhido((v || '').trim().toLowerCase()
                  .replace(/^https?:\/\//,'').replace(/^www\./,'').replace(/\/.*$/,''))}
                options={dominios.filter(d => !d.bloqueado).map(d => ({
                  value: d.dominio,
                  label: (d.recomendado ? '✅ ' : '⚠️ ') + d.dominio +
                         (d.alerta ? ' — ' + d.alerta : '')
                }))}
                allowClear
              />
              <Button onClick={async () => {
                try {
                  await api.put(`/prospeccao/lead/${leadDetalhe.id}/dominio`, { dominio: dominioEscolhido });
                  message.success('Domínio salvo');
                } catch (e) { message.error(e.response?.data?.erro || 'Erro ao salvar'); }
              }}>Salvar</Button>
              <Button type="primary" loading={buscandoEmails}
                disabled={!dominioEscolhido}
                onClick={async () => {
                  setBuscandoEmails(true);
                  try {
                    const r = await api.post(`/prospeccao/lead/${leadDetalhe.id}/buscar`,
                      { dominio: dominioEscolhido });
                    if (r.data.status === 'ok') {
                      message.success(`${r.data.gerados} e-mails (${r.data.publicados} achados no site)`);
                      const em = await api.get(`/leads/${leadDetalhe.id}/emails`);
                      setEmailsLead(em.data || []);
                    } else {
                      message.warning(r.data.motivo || r.data.status);
                    }
                  } catch (e) { message.error(e.response?.data?.erro || 'Erro na busca'); }
                  setBuscandoEmails(false);
                }}>Buscar e-mails</Button>
            </Space.Compact>
            {dominios.some(d => d.bloqueado) &&
              <p style={{ fontSize: 12, color: '#cf1322', marginTop: 0 }}>
                🚫 = domínio de contabilidade ou terceiro — use o enriquecimento para achar o site real.
              </p>}

            <Divider>📧 E-mails</Divider>
            {emailsLead.length === 0 ? <p style={{color:'#888'}}>Nenhum e-mail cadastrado</p> :
              emailsLead.map(e => (
                <Tag key={e.id} color={e.valido === false ? 'red' : e.origem === 'gemini' ? 'blue' : 'default'} style={{marginBottom:4}}>
                  {e.nome_contato ? <><strong>{e.nome_contato}</strong> — </> : ''}{e.email}
                  {e.origem === 'gemini' && ' 🤖'}
                  {e.observacao && <span style={{fontSize:11, color:'#666'}}> — {e.observacao}</span>}
                </Tag>
              ))
            }
            <Divider>📱 Telefones</Divider>
            {telefonesLead.length === 0 ? <p style={{color:'#888'}}>Nenhum telefone cadastrado</p> :
              telefonesLead.map(t => (
                <Tag key={t.id} color={t.origem === 'gemini' ? 'blue' : 'default'} style={{marginBottom:4}}>
                  <a href={'https://wa.me/55' + t.telefone.replace(/\D/g,'')} target="_blank" rel="noreferrer">
                    📱 {t.telefone}
                  </a>
                  {t.origem === 'gemini' && ' 🤖'}
                  {t.observacao && <span style={{fontSize:11, color:'#666'}}> — {t.observacao}</span>}
                </Tag>
              ))
            }
            <Divider>📊 Funil de Vendas</Divider>
            <Select value={leadDetalhe.funil || 'novo'} style={{width:'100%', marginBottom:16}}
              onChange={async v => {
                await api.put(`/leads/${leadDetalhe.id}/funil`, { funil: v });
                setLeadDetalhe(prev => ({...prev, funil: v}));
                carregar();
              }}>
              <Select.Option value="novo">🆕 Novo</Select.Option>
              <Select.Option value="contatado">📞 Contatado</Select.Option>
              <Select.Option value="interessado">⭐ Interessado</Select.Option>
              <Select.Option value="proposta">📄 Proposta Enviada</Select.Option>
              <Select.Option value="convertido">✅ Convertido em Cliente</Select.Option>
              <Select.Option value="perdido">❌ Perdido</Select.Option>
            </Select>

            <Divider>📅 Lembretes</Divider>
            {lembretesLead.filter(l => !l.concluido).map(l => (
              <div key={l.id} style={{display:'flex', justifyContent:'space-between', padding:'6px 0', borderBottom:'1px solid #f0f0f0'}}>
                <span style={{fontSize:12}}>{new Date(l.data_lembrete).toLocaleString('pt-BR')} — {l.descricao}</span>
                <Button size="small" type="link" onClick={() => concluirLembrete(l.id)}>✓ Concluir</Button>
              </div>
            ))}
            <div style={{display:'flex', gap:8, marginTop:8}}>
              <Input placeholder="Descrição do lembrete" value={novoLembrete.descricao} onChange={e => setNovoLembrete(p => ({...p, descricao: e.target.value}))} size="small" />
              <Input type="datetime-local" value={novoLembrete.data_lembrete} onChange={e => setNovoLembrete(p => ({...p, data_lembrete: e.target.value}))} size="small" style={{width:180}} />
              <Button size="small" type="primary" onClick={salvarLembrete}>+</Button>
            </div>

            <Divider>📋 Histórico de Contatos</Divider>
            <div style={{display:'flex', gap:8, marginBottom:8, flexWrap:'wrap'}}>
              <Select value={novoContato.tipo} onChange={v => setNovoContato(p => ({...p, tipo: v}))} size="small" style={{width:120}}>
                <Select.Option value="ligacao">📞 Ligação</Select.Option>
                <Select.Option value="email">📧 E-mail</Select.Option>
                <Select.Option value="whatsapp">💬 WhatsApp</Select.Option>
                <Select.Option value="visita">🚗 Visita</Select.Option>
                <Select.Option value="outro">📝 Outro</Select.Option>
              </Select>
              <Select value={novoContato.resultado} onChange={v => setNovoContato(p => ({...p, resultado: v}))} size="small" style={{width:150}}>
                <Select.Option value="sem_resposta">Sem resposta</Select.Option>
                <Select.Option value="interessado">Interessado</Select.Option>
                <Select.Option value="nao_interessado">Não interessado</Select.Option>
                <Select.Option value="callback">Vai retornar</Select.Option>
                <Select.Option value="convertido">Convertido!</Select.Option>
              </Select>
              <Input placeholder="Descreva o contato..." value={novoContato.descricao} onChange={e => setNovoContato(p => ({...p, descricao: e.target.value}))} size="small" style={{flex:1}} />
              <Button size="small" type="primary" onClick={registrarContato}>Registrar</Button>
            </div>
            {historicoLead.map(h => (
              <div key={h.id} style={{padding:'6px 8px', marginBottom:4, background:'#f9f9f9', borderRadius:4, fontSize:12}}>
                <strong>{h.tipo === 'ligacao' ? '📞' : h.tipo === 'email' ? '📧' : h.tipo === 'whatsapp' ? '💬' : h.tipo === 'visita' ? '🚗' : '📝'} {h.usuario_nome}</strong>
                <span style={{color:'#888', marginLeft:8}}>{new Date(h.criado_em).toLocaleString('pt-BR')}</span>
                <Tag size="small" color={h.resultado === 'interessado' ? 'green' : h.resultado === 'convertido' ? 'blue' : h.resultado === 'nao_interessado' ? 'red' : 'default'} style={{marginLeft:8}}>
                  {h.resultado?.replace('_', ' ')}
                </Tag>
                <div style={{marginTop:4}}>{h.descricao}</div>
              </div>
            ))}

            {enriquecimentoLead && <>
              <Divider>🤖 Dados enriquecidos pela IA</Divider>
              <Row gutter={16}>
                {enriquecimentoLead.site && <Col span={24} style={{marginBottom:8}}><strong>🌐 Site:</strong> <a href={enriquecimentoLead.site} target="_blank" rel="noreferrer">{enriquecimentoLead.site}</a></Col>}
                {(enriquecimentoLead.extras?.links || []).length > 0 && <Col span={24} style={{marginBottom:8}}><strong>🔗 Outros links:</strong>{enriquecimentoLead.extras.links.map((k, i) => <div key={i} style={{fontSize:12}}><a href={k.url} target="_blank" rel="noreferrer">{k.url}</a>{k.observacao ? ' — ' + k.observacao : ''}</div>)}</Col>}
                {enriquecimentoLead.extras?.busca && <Col span={24} style={{marginBottom:8, fontSize:12, color:'#666'}}><strong>🔎 Busca feita com:</strong><br/><span style={{whiteSpace:'pre-line'}}>{enriquecimentoLead.extras.busca}</span></Col>}
                {enriquecimentoLead.extras?.maps && <Col span={24} style={{marginBottom:8}}><strong>📍 Google Maps:</strong> <a href={enriquecimentoLead.extras.maps.link} target="_blank" rel="noreferrer">{enriquecimentoLead.extras.maps.nome}</a>{enriquecimentoLead.extras.maps.endereco ? ' — ' + enriquecimentoLead.extras.maps.endereco : ''}{enriquecimentoLead.extras.maps.status === 'CLOSED_PERMANENTLY' && <Tag color="red" style={{marginLeft:8}}>Fechada permanentemente</Tag>}{enriquecimentoLead.extras.maps.status === 'CLOSED_TEMPORARILY' && <Tag color="orange" style={{marginLeft:8}}>Fechada temporariamente</Tag>}</Col>}
                {enriquecimentoLead.whatsapp && <Col span={12} style={{marginBottom:8}}><strong>💬 WhatsApp:</strong> <a href={'https://wa.me/55' + enriquecimentoLead.whatsapp.replace(/\D/g,'')} target="_blank" rel="noreferrer">{enriquecimentoLead.whatsapp}</a></Col>}
                {enriquecimentoLead.instagram && <Col span={12} style={{marginBottom:8}}><strong>📸 Instagram:</strong> <a href={'https://instagram.com/' + enriquecimentoLead.instagram.replace('@','')} target="_blank" rel="noreferrer">{enriquecimentoLead.instagram}</a></Col>}
                {enriquecimentoLead.facebook && <Col span={24} style={{marginBottom:8}}><strong>👍 Facebook:</strong> <a href={enriquecimentoLead.facebook} target="_blank" rel="noreferrer">{enriquecimentoLead.facebook}</a></Col>}
                {enriquecimentoLead.observacoes_gemini && <Col span={24}><strong>📝 Observações:</strong><br/><span style={{fontSize:12}}>{enriquecimentoLead.observacoes_gemini}</span></Col>}
              </Row>
              <div style={{marginTop:8, fontSize:11, color:'#888'}}>Enriquecido em: {new Date(enriquecimentoLead.enriquecido_em).toLocaleString('pt-BR')}</div>
            </>}
          </div>
        )}
      </Modal>
    </div>
  );
}
